{
  "replaceMessage": "Spustite datoteko za zamenjavo"
}
